import React from 'react'
import "./TrendingProducts.css"
import PropTypes from "prop-types";
import { Autoplay, Pagination } from 'swiper/modules';
import ProductItem from "../ProductItem/ProductItem"
import { Col, Container, Row } from "react-bootstrap";
import 'swiper/css/pagination';
import 'swiper/css';
import 'swiper/css/pagination';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
function TrendingProducts({products}) {
    const { currentLocal } = useSelector((state) => state.currentLocal);

    return (
        <div className='mb-5 best_selling_container'>
            <Container>
                <di className="d-flex justify-content-between">
                    <p className='fw-bold fs-5'>{currentLocal.home.bestseller}</p>
                    {products.length>8&&
                    <Link className='text-black'to={"/collections"}>{currentLocal.home.seeMore}</Link>
}
                </di>
       <Container>
        <Row>
            {products?.splice(0,7)?.map((item,index)=>{
                return(
                    <Col md={3}key={index}>
                        <ProductItem
product={item}
/>
                                            </Col>
                )
            })}
        </Row>
       </Container>
                {/* <Row>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}
                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}
                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Herbal%20Renewal%20Face%20Serum.jpg"}
                            title={"Marshmallow Butter"}
                            price={"150 EGP"}

                        />
                    </Col>
                    <Col md={3}>
                        <ProductItem
                            img={"https://smileheavenglow.com/images/products/Marshmallow%20Butter.jpg"}
                            title={"Herbal Renewal Face Serum"}
                            price={"250 EGP"}

                        />
                    </Col>
                </Row> */}
            </Container>
        </div>
    )
}

export default TrendingProducts